import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";

const LineChart = (props) => {
  let { data: dataJson, design } = props;
  const [setting, setSetting] = useState(null);
  
  const values = Object.values(dataJson.data);
  const delta = Math.max(...values) - Math.min(...values) || 1;

  let settings = {
    default: {
      options: {
        layout: {
          padding: {
            top: 10,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            align: "start",
            clamp: true,
            anchor: "end",
            offset: -20,
            display: true,
            formatter: (value) => new Intl.NumberFormat("pt-BR").format(value)
          },
          tooltip: {
            callbacks: {
              title: function(tooltipItem) {
                const originalLabel = Object.keys(dataJson.data)[tooltipItem[0]['dataIndex']];
                return `${originalLabel}`;
              },
              label: function(tooltipItem) {
                const originalLabel = Object.keys(dataJson.data)[tooltipItem['dataIndex']];
                return `${new Intl.NumberFormat('pt-BR').format(dataJson.data[originalLabel])}`;
              }
            }
          }
        },
        scales: {
          y: {
            display: false,
            max: Math.max(...values) + 0.1*delta,
            min: Math.min(...values) - 0.1*delta
          },
          x: {
            display: true,
            ticks: {
              fontSize: 14,
            },
          },
        },
      },
      data: {
        datasets: [
          {
            borderColor: "#9A2376",
            backgroundColor: "#9A2376",
          },
        ],
      },
    },
  };

  useEffect(() => {
    let setDesign = settings[design] ? settings[design] : settings["default"];

    setDesign.data.labels = Object.keys(dataJson.data);
    setDesign.data.datasets[0].data = Object.values(dataJson.data);
    setDesign.data.datasets[0].label = dataJson.dataLabel;

    setSetting(setDesign);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {setting !== null && (
        <Line {...props} data={setting.data} options={setting.options} />
      )}
    </>
  );
};

export default LineChart;
